// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"k1-z","button":"l1-z","disabled":"m1-z","creditCard":"n1-z","wrapper":"o1-z"};